const Debouncer = {

  record : {},

  debounce : (fn, delay, timerId) => {
    let timer = null;
    return (() => {
      try {
        timer = Debouncer.record[timerId];
        clearTimeout(timer);
        Debouncer.record[timerId] = setTimeout(() => {
          fn.apply(this, arguments);
        }, delay);
      } catch(err) {
        console.log('err', err)
      }
    })()
  }

}

export default Debouncer;
//For test script
//module.exports = Debouncer;



// WEBPACK FOOTER //
// ./src/infra/Debouncer.js